<template>
  <v-dialog v-model="dialog" persistent max-width="800">
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title">Criar Relatório Final</slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="dialog = false" color="white"
              >mdi-window-close</v-icon
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-row class="text-center">
            <v-col>
              <v-text-field
                v-model="municipio.linkRelFinalCliOculto"
                label="Link para o cliente oculto"
                :rules="rules"
                placeholder="https://www.google.com/"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="dialog = false"
          >Fechar</v-btn
        >
        <v-btn color="info" outlined text @click="updateMunicipio('save')"
          >Salvar</v-btn
        >
        <v-btn color="info" outlined text @click="updateMunicipio('download')"
          >Salvar e Baixar</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { cityAPI } from "@/modules/city";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "AppModalInsertAttendance",
  props: {
    dialog: { type: Boolean },
    municipio: { type: Object },
  },
  computed: {
    ...mapGetters(["loading", "user"]),
  },
  data() {
    return {
      rules: [
        (v) => {
          let string = v && v.trim();
          if (!string) return true;

          if (!this.ValidURL(string)) return "Link inválido";

          return true;
        },
      ],
    };
  },
  methods: {
    ...mapActions(["setLoading"]),
    ValidURL(str) {
      var regex = /^(?:\w+:)?\/\/([^\s\.]+\.\S{2}|localhost[\:?\d]*)\S*$/;
      if (!regex.test(str)) {
        return false;
      } else {
        return true;
      }
    },
    async check() {
      const isValid = await this.$refs.form.validate();
      return isValid;
    },
    async updateMunicipio(v) {
      let isValid = await this.check();

      if (!isValid) return;
      this.setLoading(true);

      cityAPI
        .update(this.municipio)
        .then((resp) => {
          if (v == "download") this.$emit("relFimCriado");
          else {
            this.$emit("atualizarRelatorio");
          }
          // this.setLoading(false);
        })
        .catch((resp) => {
          console.log("Erro ao salvar municipio: ", resp);
          this.setLoading(false);
          this.$notification.error("Erro ao salvar link");
        });
    },
  },
};
</script>
